<template>
  <div class="fx_content" style="padding-top:10px">

    <div class="fenxi_con">

      <a-row class="fxheight">
        <a-col :span="12">
          <a-row>
            <a-col :span="24">
              <div class="fxlist">
                <div><img src="@/assets/fenxi1.png" /></div>
                <div>
                  <h1 class="fxnum">{{ fenxi.charge_total }}<span>kw/h</span></h1>
                  <h2 class="fxzi">当前可充电总量</h2>
                </div>
              </div>
            </a-col>

            <a-col :span="24">
              <div class="fxlist">
                <div><img src="@/assets/fenxi3.png" /></div>
                <div>
                  <h1 class="fxnum">{{ fenxi.discharge_total }}<span>kw/h</span></h1>
                  <h2 class="fxzi">当前可放电总量</h2>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-row>
            <a-col :span="24">
              <div class="fxlist">
                <div><img src="@/assets/fenxi2.png" /></div>
                <div>
                  <h1 class="fxnum">{{ fenxi.today_money_save }}<span>元</span></h1>
                  <h2 class="fxzi">当日节省电费</h2>
                </div>
              </div>
            </a-col>
            <a-col :span="24">
              <div class="fxlist">
                <div><img src="@/assets/fenxi4.png" /></div>
                <div>
                  <h1 class="fxnum">{{ fenxi.month_money_save }}<span>元</span></h1>
                  <h2 class="fxzi">当月节省电费</h2>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>

import { defineComponent } from "vue";

export default defineComponent({
  name: "FenXi",
  components: {},
  props: { fenxi: Object },

});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fx_content {
  position: relative;
  /*相对位置*/
  height: calc(100% - 15px);
}

.fenxi {

  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}

.fenxi_con {
  width: 100%;
  position: absolute;
  height: 100%;
}

.fxheight {
  overflow: hidden;
  background-repeat: no-repeat;
}

.title {
  color: #5ce7f0;
  font-size: 16px;
  padding: 10px 30px 10px 50px;
  background: url("@/assets/biao.png") 10px 5px;
  background-repeat: no-repeat;
}

.fxlist {
  display: flex;
  padding-left: 20px;
  margin-bottom: 30px;
  margin-top: 10px;
}

.fxlist img {
  margin-right: 8px;
}

.fxzi {
  color: #bcc4ce;
  font-size: 14px;
}

.fxnum {
  color: #2489ff;
  font-size: 24px;
  font-family: Arial, Helvetica, sans-serif;
  padding: 0;
  margin: 0;
  letter-spacing: 1px;
  font-weight: bold;
}

.fxnum span {
  font-size: 14px
}
</style>
